import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { LoadingComponent } from '@/components/loading/loading.component';
import { Utils } from '@/utils/utils';
import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, ChangeDetectorRef, OnInit, signal } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DecimalInputDirective } from '@/directives/decimal-input.directive';

@Component({
  selector: 'app-taxes-form',
  imports: [
    DecimalInputDirective,
    CommonModule,
    CustomModalComponent,
    ReactiveFormsModule,
    LoadingComponent,
  ],
  templateUrl: './taxes-form.component.html',
  styleUrl: './taxes-form.component.scss',
})
export class TaxesFormComponent implements OnInit {
  @Output() closeFunction = new EventEmitter<any>();
  @Output() acceptFunction = new EventEmitter<any>();

  public loading = signal(false);
  public saving = signal(false);
  public saveForm: FormGroup = new FormGroup({});
  public dropdowns: any = {
    taxes: []
  };


  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getPetition();
  }

  createForm() {
    this.saveForm = new FormGroup({
      tax_config: new FormArray([])
    });
  }

  get taxItems() {
    return this.saveForm.get('tax_config') as FormArray;
  }

  addTaxRow(data: any = { id: 0 }) {
    this.taxItems.push(new FormGroup({
      id: new FormControl(data.id || 0),
      quotient: new FormControl(data.quotient || '', [Validators.required]),
    }));
  }

  removeTaxRow(index: number) {
    this.taxItems.removeAt(index);
  }


  getPetition() {
    this.loading.set(true);
    const config = { companies: {} };
    this.apiService.getSelectors(Urls.urls.selectors, config).subscribe({
      next: (data: any) => {
        const company = data.companies[0];
        this.taxItems.clear();

        if (company && company.tax_config) {
          const taxes = JSON.parse(company.tax_config)

          if (taxes && Array.isArray(taxes)) {
            taxes.forEach((item: any) => this.addTaxRow(item));
          }
        }

        this.loading.set(false)
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.loading.set(false);
        console.error('Error:', error);
      },
      complete: () => this.loading.set(false)
    });
  }

  saveEntity() {
    if (this.saveForm.valid) {
      this.saving.set(true);

      const payload = {
        ...this.saveForm.value
      }

      // change id for new taxes

      let lastId = 0;

      // this is to get the last id 
      payload.tax_config.map((tax: any) => {
        if (tax.id != 0 && lastId < tax.id) {
          lastId = tax.id
        }
      })

      // this is to change the id for new taxes
      payload.tax_config.map((tax: any) => {
        if (tax.id == 0) {
          tax.id = ++lastId;
        }
      })

      // -- end -- change id for new taxes

      this.apiService.save(Urls.urls.companyTaxes, this.saveForm.value, 0).subscribe({
        next: (response: any) => {
          Utils.notification.success("Tipo de IVA guardado")
          this.acceptFunction.emit(response);
          this.closeFunction.emit();
        },
        error: (error) => {
          this.saving.set(false);
          Utils.notification.alert(Utils.extractErrorMessage(error) || "Error al guardar el tipo de IVA")
        },
        complete: () => this.saving.set(false)
      });
    } else {
      Utils.notification.alert("Debe completar todos los campos obligatorios")
    }
  }

  acceptFormFunction() { this.saveEntity(); }
  closeFormFunction() { this.closeFunction.emit(); }
}